import React, { FC, memo } from "react";
import { createUseStyles } from "react-jss";

import Map from "Containers/Map";
import MapActionLinks from "Containers/MapActionLinks";
import { areEqualShallow } from "Utils/areEqual";
import ShareMenuContainer from "Containers/ShareMenu";
import ZoomControl from "Components/ZoomControl";
import { MapSwitcherContainer } from "Containers/MapSwitcher";
import MapType from "Components/MapType";
import Geolocation from "Components/Geolocation";
import SearchAIButton from "Assets/images/search_icon.svg";

import Icon from "Components/Icons";
import PrivacyPreferences from "Components/PrivacyPreferences";
import { checkIsTrailsEnabled } from "Utils/utils";
import styles from "./styles";

interface Props {
  setZoom: (val: number) => void;
  showSwitcher: boolean;
  currentView: string;
  actionButtonsConfig: any;
  defaultActionButtonsConfig: any;
  children: any;
  showHideList: () => void;
  showTrails: () => void;
  mapObj: any;
  locId: any;
  view: string;
  trailsOption: boolean;
  trailsCount: number;
  showSearchOptions: any;
  showIMapFeatures: boolean;
  showSearchAI: boolean;
  setShowSearchAIPrompt: () => void;
}
const CampusMap: FC<Props> = memo((props: Props) => {
  const {
    setZoom,
    locId,
    actionButtonsConfig,
    defaultActionButtonsConfig,
    children,
    showHideList,
    showTrails,
    trailsOption,
    trailsCount,
    showSwitcher,
    currentView,
    mapObj,
    view,
    showSearchOptions,
    showIMapFeatures,
    showSearchAI,
    setShowSearchAIPrompt,
  } = props;
  const useStyles = createUseStyles(styles);
  const classes = useStyles({ ...props });

  return (
    <div className={classes.container}>
      {showIMapFeatures && (
        <>
          <MapActionLinks
            actionButtonsConfig={actionButtonsConfig}
            defaultActionButtonsConfig={defaultActionButtonsConfig}
            className={`${classes.mapActionButtonsPosition} ${
              !showSearchOptions ? classes.higherIndex : ""
            } ${!trailsOption ? classes.lowerIndex : ""}`}
          />
          {mapObj && (
            <div role="tablist" className={classes.bottomMenu}>
              {showSwitcher ? (
                <MapSwitcherContainer searchbarOption={view} />
              ) : (
                ""
              )}
              <PrivacyPreferences />
              {showSearchAI && (
                <button
                  className={classes.SearchAIButton}
                  aria-label="search AI"
                  tabIndex={0}
                  /* target="_self" */
                  type="button"
                  onClick={setShowSearchAIPrompt}
                >
                  <SearchAIButton />
                </button>
              )}
              {(!showSwitcher || currentView === "mapview") && (
                <MapType mapObj={mapObj} />
              )}
              <ShareMenuContainer
                url={window.location.href}
                backgroundColor="white"
              />
              <div aria-label="Zoom controls" className={classes.zoomHolder}>
                <ZoomControl setZoom={setZoom} mapObj={mapObj} />
              </div>
              <Geolocation mapObj={mapObj} />
            </div>
          )}
          <div className={`${classes.searchOptionsPosition}`}>{children}</div>
          {!showSearchOptions && (
            <div className={classes.mobileButtons}>
              <div className={classes.iconContainer}>
                <div className={classes.verticalAlignChild}>
                  <Icon
                    type="destinationsMobile"
                    tabIndex={0}
                    aria-label="Show Destinations"
                    events={{
                      onClick: showHideList,
                    }}
                  />
                </div>
              </div>
              {checkIsTrailsEnabled(trailsCount) && (
                <div className={classes.iconContainer}>
                  <div className={classes.verticalAlignChild}>
                    <Icon
                      type="trails"
                      tabIndex={0}
                      aria-label="Show Trails"
                      events={{
                        onClick: showTrails,
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
      <Map locId={locId} mapObj={mapObj} />
    </div>
  );
}, areEqualShallow);

export default CampusMap;
